import type { FC } from 'react';
import type { Control } from 'react-hook-form';

import { TextInput } from '../../../../components/reactHookFormMantine/TextInput.tsx';
import { useI18n } from '../../../../hooks/useI18n.ts';
import type { IncompleteEventFormComplete } from '../../IncompleteEventForm/schema.ts';

export const OnlineEventSettings: FC<{
  control: Control<IncompleteEventFormComplete>;
}> = ({ control }) => {
  const { t } = useI18n();

  return (
    <TextInput
      control={control}
      label={t('where-and-when_label--online-link') ?? 'Online link'}
      name="onlineLink"
      placeholder={t('where-and-when_placeholder--online-link') ?? 'Link where the event will take place'}
      type="input"
    />
  );
};
